module.exports = __webpack_public_path__ + "img/qrcode2.55053e60.jpg";